import {
  takeEvery, call, put, all
} from 'redux-saga/effects';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch.js';
import { actions, actionCreators } from 'react/api/actions/dashboardAnalytics';

function* refreshAnalyticsToken(document) {
  let access_token = "";
  if (isAnalyticsMultiTenant()) {
    const url = encodeURI('/Token/analyticsClaims?scope=gm-live:analytics&client_id=gm-saml');
    const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
    const jwtClaims = yield call(defaultFetch, url, {}, 'GET', headers);
    
    const gmTokensUrl = encodeURI('/jwt/token');
    const tokenResponse = yield call(defaultFetch, gmTokensUrl, jwtClaims, 'POST', headers);

    access_token = tokenResponse;
  } 

  yield put(actionCreators.setAnalyticsToken(access_token));
}

function* checkAnalyticsHealth() {
  const url = encodeURI(`/${getAnalyticsEndpoint()}/api/health`);
  const response = yield call(defaultFetch, url);
  const { error } = response;
  yield put(actionCreators.setAnalyticsHealth(!error));
}

function isAnalyticsMultiTenant() {
  const featureState = Monet.Session.ApplicationLoad.featureStates.find(obj => obj.name==="GM_ANALYTICS_MULTITENANT");
  return featureState?.enabled;
}

function getAnalyticsEndpoint() {
  return isAnalyticsMultiTenant() ? 'analytics-service' : 'analytics';
}

function* watchRefreshAnalyticsToken() {
  yield takeEvery(actions.refreshAnalyticsToken, refreshAnalyticsToken);
}

function* watchCheckAnalyticsHealth() {
  yield takeEvery(actions.checkAnalyticsHealth, checkAnalyticsHealth);
}

export default function* () {
  yield all([
    watchRefreshAnalyticsToken(),
    watchCheckAnalyticsHealth(),
    getAnalyticsEndpoint,
  ]);
}
